<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <div class="fl w-260 m-r-30">
        <el-input placeholder="请输入名称" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
      <div class="fl w-150">
        <el-select v-model="type" clearable placeholder="选择报销状态" v-on:change="getAllUsers()" class="w-150">
          <el-option label="默认排序" :value="0"></el-option>
          <el-option label="点击量降序" :value="1"></el-option>
          <el-option label="点击量升序" :value="2"></el-option>
        </el-select>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="name"
      label="名称">
      </el-table-column>
      <el-table-column
      prop="value"
      label="接口">
      </el-table-column>
      <el-table-column
      prop="count"
      label="点击量">
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import http from '../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        multipleSelection: [],
        keywords: '',
        type: 0,
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit,
            type: this.type
          }
        }
        this.apiGet('admin/filesIndex/click_list', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      init() {
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('lunbo-save')
      },
      editShow() {
        return _g.getHasRule('lunbo-update')
      },
      deleteShow() {
        return _g.getHasRule('lunbo-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// click_list.vue?b3604764